import React from "react";

interface Options<F extends Record<string, unknown>, K extends keyof F> {
  filters: F;
  setFilters: (next: F) => void;
  viewerActiveTeamIds: string[];
  filterKey: K;
}

// Seeds `filters[filterKey] = [...viewerActiveTeamIds, null]` exactly once,
// only when the URL carries no filter state at all. Ref-guarded write during
// render so the seed lands before the first fetch — an effect would flash an
// unscoped result set. No-op if the URL carries any filter state.
export function useTeamFilterDefaultSeeding<
  F extends Record<string, unknown>,
  K extends keyof F,
>({ filters, setFilters, viewerActiveTeamIds, filterKey }: Options<F, K>) {
  const hasSeededRef = React.useRef(false);

  if (!hasSeededRef.current) {
    hasSeededRef.current = true;

    const urlIsBlank = Object.keys(filters).length === 0;
    if (urlIsBlank && viewerActiveTeamIds.length > 0) {
      const teamIdsWithUnassigned: Array<string | null> = [
        ...viewerActiveTeamIds,
        null,
      ];
      setFilters({
        ...filters,
        [filterKey]: teamIdsWithUnassigned,
      });
    }
  }
}
